// extracted by mini-css-extract-plugin
export default {"sidemenu-main":"Sidemenu_sidemenu-main__7YzYP","avatar":"Sidemenu_avatar__O9IGM","name":"Sidemenu_name__JZko7","options":"Sidemenu_options__jTBW1","active":"Sidemenu_active__1vOV7"};